
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import ProTitle from '../../components/ProTitle';
import './index.less'
import { Modal,Tabs } from 'antd';
import proicon from "../../static/images/proicon.png"

const imageNumbers = Array.from({ length: 80 }, (_, i) => i + 1);

// 动态导入所有图片，生成图片路径数组
const images = imageNumbers.map((num) => {
  return require(`../../static/aiprt/zqc${num}.jpg`);
});

export default function App() {
  const memo = ' '
  const memob ='基于国产信创数智底座、Multi-Agent System等开发的远东招标采购与供应链数智化产品及平台。随着市场、技术的发展，客户提出新的需求，同时原有SAAS模式与对应的业务及技术升级系统、拓展相关的互联互通'
  const item =[
    {
      name:'AiPRT平台',
      type:'link',
      list:[
        {name:'AiPRT公共资源数智采平台', link:'https://www.aipuret.cn',},
      ]
    },
    {
      name:'政府采购',
      list:[
        {name:'公开招标流程系统', img:images[76],},
        {name:'创新采购流程系统', img:images[54],},
        {name:'竞争性磋商流程系统', img:images[56],},
        {name:'竞争性谈判流程系统', img:images[66],},
        {name:'框架协议流程系统', img:images[63],},
        {name:'邀请招标流程系统', img:images[73],},
        {name:'询价流程系统', img:images[74],},
        {name:'单一来源流程系统', img:images[79],},

        {name:'政府智能采购管理系统', img:images[70],},
        {name:'公共资源数智采平台', img:images[53],},
        {name:'公共资源竞价直采管理系统', img:images[77],},
        {name:'公共资源竞价策略优化平台', img:images[68],},
        {name:'公共资源交易运营支撑系统', img:images[12],},
        {name:'公共资源交易合规性风控管理系统', img:images[11],},
        
        {name:'科研院校资源共享与管理系统', img:images[64],},
        {name:'医院与企业联合招标采购平台', img:images[67],},
        {name:'医院招标采购决策支持系统', img:images[71],},
        {name:'医院精细化招标采购系统', img:images[73],},

        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'市场调研和采购需求管理系统', img:images[29],},
        {name:'连接型公共资源交易综合系统', img:images[21],},
        {name:'国密SM4加密交易系统', img:images[13],},
        {name:'数据管理系统', img:images[30],},
        {name:'法规政策适配交易平台', img:images[8],},
        {name:'法规政策及知识库系统', img:images[7],},
        {name:'电子商城交易平台', img:images[6],},
        {name:'电子评标辅助系统', img:images[5],},
        {name:'交易主体诚信评价分析系统', img:images[18],},
        {name:'安全共享数据采集与建模平台', img:images[0],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'数智分析库系统', img:images[32],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
      ]
    },
    {
      name:'建设工程',
      list:[
        {name:'建设工程公开招标系统', img:images[14],},
        {name:'建设工程招标电子化招标平台', img:images[55],},
        {name:'设工程招标智能分析系统', img:images[57],},
        {name:'建设工程竞争性磋商系统', img:images[15],},
        {name:'建设工程竞争性谈判系统', img:images[16],},
        {name:'建设工程邀请招标系统', img:images[17],},
        {name:'建设工程招标电子化交易平台', img:images[59],},
        {name:'公开招标流程系统', img:images[76],},
        {name:'竞争性谈判流程系统', img:images[66],},
        {name:'邀请招标流程系统', img:images[73],},
        {name:'询价流程系统', img:images[74],},
        {name:'单一来源流程系统', img:images[79],},

        {name:'公共资源数智采平台', img:images[53],},
        {name:'公共资源竞价直采管理系统', img:images[77],},
        {name:'公共资源竞价策略优化平台', img:images[68],},
        {name:'公共资源交易运营支撑系统', img:images[12],},
        {name:'公共资源交易合规性风控管理系统', img:images[11],},

        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'市场调研和采购需求管理系统', img:images[29],},
        {name:'交易主体诚信评价分析系统', img:images[18],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'数智分析库系统', img:images[32],},
        {name:'电子评标辅助系统', img:images[5],},
        {name:'法规政策适配交易平台', img:images[8],},
        {name:'法规政策及知识库系统', img:images[7],},
        {name:'评审定标大模型系统', img:images[23],},
        {name:'数智分析库系统', img:images[32],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
      ]
    },
    {
      name:'国企央企',
      list:[
        {name:'央企国企直接采购系统', img:images[35],},

        {name:'公开招标流程系统', img:images[76],},
        {name:'竞争性磋商流程系统', img:images[56],},
        {name:'竞争性谈判流程系统', img:images[66],},
        {name:'框架协议流程系统', img:images[63],},
        {name:'邀请招标流程系统', img:images[73],},
        {name:'询价流程系统', img:images[74],},
        {name:'单一来源流程系统', img:images[79],},
        {name:'创新采购流程系统', img:images[54],},

        {name:'公共资源竞价直采管理系统', img:images[77],},

        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'市场调研和采购需求管理系统', img:images[29],},
        {name:'国密SM4加密交易系统', img:images[13],},
        {name:'数据管理系统', img:images[30],},
        {name:'法规政策适配交易平台', img:images[8],},
        {name:'法规政策及知识库系统', img:images[7],},
        {name:'电子商城交易平台', img:images[6],},
        {name:'电子评标辅助系统', img:images[5],},
        {name:'交易主体诚信评价分析系统', img:images[18],},
        {name:'安全共享数据采集与建模平台', img:images[0],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'数智分析库系统', img:images[32],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
      ]
    },
    {
      name:'产权交易',
      list:[
        {name:'产权交易单一谈判系统', img:images[1],},
        {name:'产权交易公开竞价系统', img:images[2],},
        {name:'产权交易邀请竞价系统', img:images[3],},

        {name:'公开招标流程系统', img:images[76],},
        {name:'创新采购流程系统', img:images[54],},
        {name:'竞争性磋商流程系统', img:images[56],},
        {name:'竞争性谈判流程系统', img:images[66],},
        {name:'框架协议流程系统', img:images[63],},
        {name:'邀请招标流程系统', img:images[73],},
        {name:'询价流程系统', img:images[74],},
        {name:'单一来源流程系统', img:images[79],},

        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'国密SM4加密交易系统', img:images[13],},
        {name:'数据管理系统', img:images[30],},
        {name:'法规政策适配交易平台', img:images[8],},
        {name:'法规政策及知识库系统', img:images[7],},
        {name:'电子商城交易平台', img:images[6],},
        {name:'电子评标辅助系统', img:images[5],},
        {name:'交易主体诚信评价分析系统', img:images[18],},
        {name:'安全共享数据采集与建模平台', img:images[0],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'数智分析库系统', img:images[32],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
        
      ]
    },
    {
      name:'外资外贷',
      list:[
        {name:'公开招标流程系统', img:images[76],},
        {name:'竞争性磋商流程系统', img:images[56],},
        {name:'竞争性谈判流程系统', img:images[66],},
        {name:'框架协议流程系统', img:images[63],},
        {name:'邀请招标流程系统', img:images[73],},
        {name:'询价流程系统', img:images[74],},
        {name:'单一来源流程系统', img:images[79],},

        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'国密SM4加密交易系统', img:images[13],},
        {name:'数据管理系统', img:images[30],},
        {name:'法规政策适配交易平台', img:images[8],},
        {name:'法规政策及知识库系统', img:images[7],},
        {name:'电子商城交易平台', img:images[6],},
        {name:'电子评标辅助系统', img:images[5],},
        {name:'交易主体诚信评价分析系统', img:images[18],},
        {name:'安全共享数据采集与建模平台', img:images[0],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'数智分析库系统', img:images[32],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
        
      ]
    },
    {
      name:'深圳政采自行采购',
      list:[
        {name:'自行采购公开征集模式系统', img:images[47],},
        {name:'自行采购询价供应商直选系统', img:images[48],},
        {name:'自行采购询价系统', img:images[49],},
        {name:'自行采购邀请竞标系统', img:images[50],},

        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'国密SM4加密交易系统', img:images[13],},
        {name:'数据管理系统', img:images[30],},
        {name:'法规政策适配交易平台', img:images[8],},
        {name:'法规政策及知识库系统', img:images[7],},
        {name:'电子商城交易平台', img:images[6],},
        {name:'电子评标辅助系统', img:images[5],},
        {name:'交易主体诚信评价分析系统', img:images[18],},
        {name:'安全共享数据采集与建模平台', img:images[0],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'数智分析库系统', img:images[32],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
      ]
    },
    {
      name:'招标人自定义',
      list:[
        {name:'自定义电子直采商城系统', img:images[42],},
        {name:'自定义公开征集模式系统', img:images[43],},
        {name:'自定义简易招标模式系统', img:images[44],},
        {name:'自定义询价寻源系统', img:images[45],},

        {name:'公开招标流程系统', img:images[76],},
        {name:'创新采购流程系统', img:images[54],},
        {name:'竞争性磋商流程系统', img:images[56],},
        {name:'竞争性谈判流程系统', img:images[66],},
        {name:'框架协议流程系统', img:images[63],},
        {name:'邀请招标流程系统', img:images[73],},
        {name:'询价流程系统', img:images[74],},
        {name:'单一来源流程系统', img:images[79],},

        {name:'电子商城交易平台', img:images[6],},
        {name:'招标采购交易文件编制系统', img:images[36],},
        {name:'招采人业务响应低代码建模平台', img:images[37],},
        {name:'招采需求管理采购公示系统', img:images[38],},
        {name:'招采需求管理市场调研系统', img:images[39],},
        {name:'招采需求管理征求意见平台', img:images[40],},
        {name:'企业竞价采购系统', img:images[24],},
        {name:'企业谈判采购系统', img:images[25],},
        {name:'企业询比采购模式系统', img:images[26],},
        {name:'企业询价寻源系统', img:images[27],},
        {name:'数据全链路治理与分析系统', img:images[31],},
        {name:'数智分析库系统', img:images[32],},
        {name:'项目电子归档系统', img:images[34],},
        {name:'智能问答助理软件', img:images[41],},
        {name:'自动抽取及专家匹配系统', img:images[46],},
      ]
    },
    
  ]
  
  const openImg =(item)=>{
    // if(){}
    setCurrentImg(item)
    setDialogVisible(true)
  }
  const [isModalOpen, setDialogVisible] = useState(false);
  const [currentImg, setCurrentImg] = useState(null);
  const handleCancel =()=>{
    setDialogVisible(false)
  }
  return (
    <>
      <PageBox useBanner={true}>
        <div className='systerBanner'>
          <div className='textBox'>
            <h2>招标采购与供应链数智化产品及平台应用场景</h2>
            <div>
              <p>涵盖：货物、建设工程、服务、供应链和产权交易等全流程数智化智能系统产品及平台、知识库和数据治理、垂类智能大模型。</p>
              <p>遵循招标采购及供应链的规则，灵活组建招采交易方式和业务流程；支持依相关内控制度个性化定制，配置不同组织的业务规范与数智需求，为招标采购交易各参与方提供合规懂业务、智能好用、赋能增值的全生命周期体系产品和服务</p>
            </div>
          </div>
          
        </div>
        <ProTitle name={'招标采购与供应链数智化产品及平台应用场景'} memo={memo} />
        <div className='syster'>
          <Tabs
            tabPosition={'left'}
            items={item.map((item,index) => {
              return {
                label: item.name,
                key: index,
                children:<ul className='syster-ul'>
                  {item.type == 'link'?<>{item.list.map((item,index,type)=>(
                  <li key={index}>
                    <a href={item.link} target='_blank'>
                      <img src={proicon} />
                      <span>{item.name}</span>
                    </a>
                  </li>
                ))}</>:<>{item.list.map((item,index,type)=>(
                  <li className={index%3 == 1?'list':''} key={index} onClick={()=>openImg(item.img)}>
                    <img src={proicon} />
                    <span>{item.name}</span>
                  </li>
                  ))}
                </>}
                
              </ul>,
              };
            })}
          />
        </div>
        <div>
          <div className='indexBanner'>
            <div class="proTitle">
              <h3>数智采系统·业务架构</h3>
              <div class="proTitle-text">
                <p style={{margin:'0px'}}>基于国产信创数智底座、Multi-Agent System等开发的远东招标采购与供应链数智化产品及平台。</p>
                <p style={{margin:'0px'}}>随着市场、技术的发展，客户提出新的需求，同时原有SAAS模式与对应的业务及技术升级系统、拓展相关的互联互通。</p>
              </div>
            </div>
            <div style={{paddingBottom:'40px'}}>
              <div class="businessArchitecture">
                <div><span>采购立项</span><ul><li>采购计划</li><li>采购需求</li><li>项目立项</li><li>智能质检</li></ul></div>
                <div><span>发标中心</span><ul><li>项目管理</li><li>招标文件</li><li>场地预约</li><li>智能编辑</li></ul></div>
                <div style={{flex:'1.3'}}><span>投标中心</span><ul><li>招标参与</li><li>投标响应文件</li><li>投标保函（保证金）</li><li>加密管理</li></ul></div>
                <div><span>开标中心</span><ul><li>项目开标</li><li>文件解密</li><li>开标仪式</li><li>智能开标</li></ul></div>		
                <div><span>评审中心</span><ul><li>资格审查</li><li>专家评审</li><li>多轮报价</li><li>智能辅助</li></ul></div>
                <div><span>定标中心</span><ul><li>定标管理</li><li>结果公示</li><li>中标管理</li><li>AI辅助</li></ul></div>	
                <div><span>合同中心</span><ul><li>合同管理</li><li>订单融资</li><li>履约评价</li><li>智能质检</li></ul></div>
                <div><span>公共管理</span><ul><li>发布媒介</li><li>财务管理</li><li>供应商管理</li><li>专家库管理</li></ul></div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={isModalOpen}
          onCancel={handleCancel}
          width={1000}
          footer={[]}
          key={currentImg}
        >
          <div style={{textAlign:'center'}}><img src={currentImg} className='imgheight' /></div>
        </Modal>
      </PageBox>
    </>
    
  );
}
